import { Badge, Button } from 'antd'
import { ShoppingCartOutlined, UserOutlined, GlobalOutlined } from '@ant-design/icons'
import { Outlet, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useBranding } from '../../stores/branding'
import { useCartStore } from '../../stores/cart'

export default function PublicShopLayout() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const branding = useBranding()
  const cartCount = useCartStore((s) => s.items.length)

  const logoUrl = branding.data?.logo_url
  const brandName = branding.data?.product_name || 'NetCell'

  return (
    <div className="shop-layout">
      <header className="shop-layout-header">
        <div className="shop-layout-header-inner">
          <div
            className="shop-layout-brand"
            onClick={() => navigate('/shop')}
          >
            {logoUrl
              ? <img src={logoUrl} alt={brandName} className="shop-layout-logo" />
              : <span className="shop-layout-brand-name">{brandName}</span>}
          </div>
          <div className="shop-layout-actions">
            <Button type="text" onClick={() => navigate('/shop')}>
              {t('portalPublicShop.products', 'Produkte')}
            </Button>
            <Button type="text" icon={<GlobalOutlined />} onClick={() => navigate('/shop/domains')}>
              {t('portalPublicShop.domains', 'Domains')}
            </Button>
            <Badge count={cartCount} size="small" offset={[-2, 2]}>
              <Button
                type="text"
                icon={<ShoppingCartOutlined />}
                onClick={() => navigate('/cart')}
                aria-label={t('portalPublicShop.cart', 'Warenkorb')}
              />
            </Badge>
            <Button
              type="text"
              icon={<UserOutlined />}
              onClick={() => navigate('/portal/login')}
            >
              {t('portalPublicShop.login', 'Anmelden')}
            </Button>
            <Button
              type="primary"
              size="small"
              onClick={() => navigate('/portal')}
            >
              {t('portalPublicShop.goToPortal', 'Zum Kundenportal')}
            </Button>
          </div>
        </div>
      </header>
      <main className="shop-layout-main">
        <div className="content-area">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
